// The operation picker: the op code table (by type, "Fits this boat" first, type chips, search) and the
// operation form a picked code fills in (description, extra fields, estimate, the WO checklist).
// Used by New work order and by Add operation in the op panel (codeSearch with its own elements).
// Split out of app.js (docs/split-plan.md, session 2). The app.js helpers it calls come in through
// setOpCodePickerDeps() (see estimates.js for why it doesn't import app.js back). Loading an existing
// operation into the form sets the picked code through setCurrentOpCodeData().
import { usesDockmaster } from './marinaConfig';
import { escapeHTML, getDB, toastMessage } from './utilities';

let shell = null;
export function setOpCodePickerDeps(deps) { shell = deps; }

document.getElementById('selectOpCode').addEventListener('click', () => {

  document.getElementById('opCodeTable').style.display = "flex"
  document.getElementById('codeSearch').value = ''
  document.getElementById('codeSearch').focus()
  generateOpTable();
})

// Enter in the search box picks the first operation still showing.
document.getElementById('codeSearch').addEventListener('keydown', (e) => {
  if (e.key !== 'Enter') return;
  e.preventDefault();
  const first = [...document.querySelectorAll('#op-code-body .op-code-row')].find(r => r.offsetParent);
  if (first) first.click();
});

// #section-header-container-storage's old job was toggling the price
// fieldset's accordion open/closed. The G rail's price card is always
// visible now (matches the design; #work-order-form-storage-data ships with
// the 'open' class in the markup), and the header itself is now the toggle
// switch's row, so that accordion listener is retired rather than fighting
// clicks on the switch.

document.getElementById('section-header-container-customer').addEventListener('click', function() {
  const customerData = document.getElementById('work-order-form-customer-data');
  this.classList.toggle('open');
  customerData.classList.toggle('open');
});

document.getElementById('section-header-container-boat').addEventListener('click', function() {
  const boatData = document.getElementById('work-order-form-boat-data');
  this.classList.toggle('open');
  boatData.classList.toggle('open');
});

export async function updateOpenDataDB(serviceLog) {
  return new Promise(async (resolve, reject) => {
    try {
      const db = await getDB();
      const tx = db.transaction("jobData", "readwrite");
      const jobStore = tx.objectStore("jobData");

      const request = jobStore.put(serviceLog);

      request.onsuccess = function () {
        console.log("Data saved successfully to IndexedDB");
        resolve("Data saved successfully to IndexedDB");
      };

      request.onerror = function (event) {
        const err = event?.target?.error;
        reject("IndexedDB data save error: " + (err?.message || err));
      };

      tx.onerror = function (event) {
        const err = event?.target?.error;
        reject("Transaction error: " + (err?.message || err));
      };

    } catch (error) {
      reject("IndexedDB database error: " + (error?.message || error));
    }
  });
}


document.getElementById('categorySelect').addEventListener('change', () => {
  let category = document.getElementById('categorySelect').value
  let dateSection = document.getElementById('work-order-date-section');
  let haulDate = document.getElementById('work-order-form-dates-haul-date').parentElement;
  let launchDate = document.getElementById('work-order-form-dates-launch-date').parentElement;
  

  if (category === 'Winterizing') {
    dateSection.classList.remove('hidden-form-section');
    haulDate.classList.remove('hidden');
    launchDate.classList.add('hidden');
  }else if(category === 'Spring Commissioning'){
    dateSection.classList.remove('hidden-form-section');
    haulDate.classList.add('hidden');
    launchDate.classList.remove('hidden');
  }else{
    dateSection.classList.add('hidden-form-section');
    haulDate.classList.add('hidden');
    launchDate.classList.add('hidden');
  }
});


async function generateOpTable() {
  try {
    const db = await getDB();
    const transaction = db.transaction(['opCodeData'], 'readonly');
    const store = transaction.objectStore('opCodeData');

    const dataArray = await new Promise((resolve, reject) => {
      const req = store.getAll();

      req.onerror = (event) => {
        console.error('Error fetching opCode data:', event.target.errorCode);
        reject(event.target.errorCode);
      };

      req.onsuccess = () => resolve(req.result || []);
    });
    bindOpCodeClickDelegationOnce();
    processOpCodes(dataArray);

  } catch (error) {
    console.error('Database error:', error);
  }
}


// opts lets a caller point this at its own render targets instead of the
// legacy #op-table-div/#op-code-body/#op-type-chips picker (see the new
// Add-Operation modal's openAddOperationModal(), which reuses this whole
// matching/sorting/rendering pipeline for its own op-code list rather than
// duplicating it) — every field defaults to the original hardcoded ids/reads
// so every existing call site keeps working unchanged.
export function processOpCodes(dataArray, opts = {}) {
  const opTableDiv = opts.tableDiv || document.getElementById('op-table-div');
  const parentContainer = opts.codeBody || document.getElementById('op-code-body');

  if (!opTableDiv || !parentContainer) return;


  opTableDiv.scrollTop = 0;
  parentContainer.innerHTML = '';

  const customerIdEl = document.getElementById('work-order-form-customer-id');
  const engineCountEl = document.getElementById('work-order-form-boat-engine-count');
  const batteryCountEl = document.getElementById('work-order-form-boat-battery-count');
  const engineTypeEl = document.getElementById('work-order-form-boat-engine-type');
  const overallCategoryEl = document.getElementById('overallCategory');
  const categorySelectEl = document.getElementById('categorySelect');
  const boatIdEl = document.getElementById('work-order-form-boat-id');
  const lengthEl = document.getElementById('work-order-form-boat-length');
  const beamEl = document.getElementById('work-order-form-boat-beam');
  const boatTypeEl = document.getElementById('work-order-form-boat-boat-type');
  const fuelTypeEl = document.getElementById('work-order-form-boat-fuel-type');
  const formTypeEl = document.getElementById('work-order-type-select');

  const customerSelected = customerIdEl.value !== '';
  const engineCount = engineCountEl.value;
  const batteryCount = batteryCountEl.value;
  let engineType = engineTypeEl.value || '';
  const mainCategory =
    (overallCategoryEl.value === '' ? categorySelectEl.value : overallCategoryEl.value);
  const boatId = boatIdEl.value;

  const batteryInfo = batteryCount === '' ? " BATTERY COUNT IS UNKNOWN" : ` BATTERY COUNT (${batteryCount})`;
  const length = Number(lengthEl.value);
  const beam = Number(beamEl.value);
  const boatType = (boatTypeEl.value || '');
  const fuelType = (fuelTypeEl.value || '');

  if (engineType.includes('Sterndrive')) {
    engineType = engineType.replace('Sterndrive', 'Inboard');
  }

  const engineTypeLower = engineType.toLowerCase();
  const driveType = engineTypeLower.includes('sterndrive'); // preserves your existing meaning
  const boatTypeLower = boatType.toLowerCase();

  let typeContainers = {};
  const customerSpecific = [];

  // Fire-and-forget: warms opTypeOrderCache for the *next* call to this function. This call's own
  // sortOrder lookup below still uses whatever's cached so far (or the hard-coded fallback), since
  // this function renders synchronously and can't await a fetch mid-render.
  shell.ensureOpTypeOrderCache();
  const sortingOrders = shell.opTypeOrderCache && Object.keys(shell.opTypeOrderCache).length ? shell.opTypeOrderCache : shell.SORT_ORDER_FALLBACK;

  const ensureTypeContainer = (type) => {
    if (!typeContainers[type]) {
      const typeContainer = document.createElement('div');
      typeContainer.id = `type-${type}`;
      typeContainer.className = 'op-type-container';

      const typeTitle = document.createElement('h4');
      typeTitle.textContent = type;

      typeContainer.appendChild(typeTitle);
      typeContainers[type] = typeContainer;
    }
    return typeContainers[type];
  };

  let matchedContainer = null;
  const ensureMatchedContainer = () => {
    if (!matchedContainer) {
      matchedContainer = document.createElement('div');
      matchedContainer.id = 'op-matched-container';
      matchedContainer.className = 'op-type-container op-matched-container';
      const title = document.createElement('h4');
      title.className = 'op-matched-title';
      title.textContent = 'Fits this boat first';
      matchedContainer.appendChild(title);
    }
    return matchedContainer;
  };

  const fragment = document.createDocumentFragment();

  const records = Array.isArray(dataArray) ? dataArray : Object.values(dataArray);

  for (const record of records) {
    if (!record || record.id === 'lastUpdated' || record.Archived === true) continue;
    if (opts.excludeOpCodes && opts.excludeOpCodes.has(String(record.OpCode || record.id))) continue;

    const fullDesc = record.Description || '';
    const desc0 = fullDesc.split(':')[0];
    const desc0Lower = desc0.toLowerCase();
    const fullDescLower = fullDesc.toLowerCase();

    let customerSpecificOp = false;
    let matchReason = ''; // human label for whichever condition fired — not a new score, just naming the existing flag

    if (engineType !== '' && desc0Lower.includes(engineTypeLower)) {
      customerSpecificOp = true;
      matchReason = `${engineType} engine`;
    }

    if (
      customerSelected === true &&
      driveType === true &&
      (desc0Lower.includes('sterndrive') ||
        desc0Lower.includes('outdrive') ||
        desc0Lower.includes('transom assembly'))
    ) {
      customerSpecificOp = true;
      matchReason = matchReason || 'Sterndrive';
    }

    if (
      customerSelected === true &&
      boatTypeLower.includes('sail') &&
      (fullDescLower.includes('mast') ||
        fullDescLower.includes('rigging') ||
        fullDescLower.includes('sail') ||
        fullDescLower.includes('genoa') ||
        fullDescLower.includes('winches') ||
        fullDescLower.includes('mainsail'))
    ) {
      customerSpecificOp = true;
      matchReason = matchReason || 'Sailboat rig';
    }

    const frLen = record.Flat_Rate_Length;
    if (customerSelected === true && frLen && typeof frLen === 'string' && frLen.includes(',')) {
      const parts = frLen.split(',');
      const minLen = Number(parts[0]);
      const maxLen = Number(parts[1]);
      if (!Number.isNaN(minLen) && !Number.isNaN(maxLen) && length >= minLen && length <= maxLen) {
        customerSpecificOp = true;
        matchReason = matchReason || `${length}' in range`;
      }
    }

    if (customerSelected === true && batteryCount && desc0Lower.includes('batter')) {
      matchReason = matchReason || `${batteryCount} batteries`;
    }

    if (customerSpecificOp) {
      customerSpecific.push(record);
    }

    const row = document.createElement('div');
    row.className = 'op-code-row';
    row.id = record.OpCode;
    // A code with no type is listed under Other (the picker used to show "undefined").
    row.dataset.sortType = record.Sort_Op_Type || 'Other';

    if (customerSpecificOp) {
      row.classList.add('customer-specific-op');
    }

    const rowData = {
      additional: record.Additional_Category,
      category: record.Op_Category,
      opCode: record.OpCode,
      opType: record.Op_Type,
      dependency: record.Dependency,
      flatRateLength: record.Flat_Rate_Length,
      hours: record.Hours,
      description: record.Description,
      flatRatePerFoot: record.Flat_Rate_Per_Foot,
      flatRateLabor: record.Flat_Rate_Labor,
    };

    row.setAttribute('data-opcode', JSON.stringify(rowData));

    const opCodeElement = document.createElement('p');
    opCodeElement.className = 'form-data';
    opCodeElement.textContent = record.OpCode;

    const descriptionElement = document.createElement('p');
    descriptionElement.className = 'form-data';
    descriptionElement.textContent = desc0;

    row.appendChild(opCodeElement);
    row.appendChild(descriptionElement);

    if (customerSpecificOp && matchReason) {
      const reasonElement = document.createElement('span');
      reasonElement.className = 'op-code-reason';
      reasonElement.textContent = matchReason;
      row.appendChild(reasonElement);
    }

    if (record.Hours) {
      const hoursElement = document.createElement('span');
      hoursElement.className = 'op-code-hours';
      hoursElement.textContent = `${record.Hours}h est`;
      row.appendChild(hoursElement);
    }

    const type = record.Sort_Op_Type || 'Other';

    if (customerSpecificOp) {
      // Matched ops float to a dedicated section above the type-grouped
      // list, instead of staying interleaved in their normal type
      // container — same flag, just a different placement.
      ensureMatchedContainer().appendChild(row);
    } else {
      const container = ensureTypeContainer(type);
      container.appendChild(row);
    }
  }

  // A caller that already knows the work order's category (the new
  // Add-Operation modal — the WO already exists, there's no type toggle to
  // read) can pass it directly instead of going through the WO-creation
  // form's work-order-type/category-select fields.
  let selectedCategory;
  if (opts.category !== undefined) {
    selectedCategory = opts.category;
  } else {
    const formType = formTypeEl.value;
    if (formType === 'general-work-order') {
      selectedCategory = categorySelectEl.value;
    } else if (formType === 'storage-work-order') {
      selectedCategory = 'Winterizing';
    }
  }

  const sortOrder = sortingOrders[selectedCategory] || Object.keys(typeContainers);

  if (matchedContainer) {
    fragment.appendChild(matchedContainer);
  }

  // Types the category's order doesn't name (Other, new ones) still show, after the rest.
  for (const type of [...new Set([...sortOrder, ...Object.keys(typeContainers)])]) {
    if (typeContainers[type]) {
      fragment.appendChild(typeContainers[type]);
    }
  }

  parentContainer.appendChild(fragment);

  buildOpTypeChips(typeContainers, customerSpecific.length, {
    chipRow: opts.chipRow,
    codeBody: parentContainer,
    searchInput: opts.searchInput,
    resultCountEl: opts.resultCountEl,
  });
}

// Type chips — turn the Sort_Op_Type groups into a filter row. Toggling a
// chip just hides/shows rows by the data-sort-type tag set above; the
// existing codeSearch() text filter still runs independently and combines
// with whatever the chip filter already hid.
function buildOpTypeChips(typeContainers, matchedCount, opts = {}) {
  const chipRow = opts.chipRow || document.getElementById('op-type-chips');
  const codeBody = opts.codeBody || document.getElementById('op-code-body');
  if (!chipRow) return;
  chipRow.innerHTML = '';

  const makeChip = (label, count, opType, accent) => {
    const chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'op-type-chip' + (opType === '' ? ' active' : '');
    chip.dataset.opType = opType;
    if (accent) {
      const dot = document.createElement('span');
      dot.className = 'op-type-chip-dot';
      chip.appendChild(dot);
    }
    const label_ = document.createElement('span');
    label_.textContent = label;
    chip.appendChild(label_);
    const countEl = document.createElement('span');
    countEl.className = 'op-type-chip-count';
    countEl.textContent = count;
    chip.appendChild(countEl);
    return chip;
  };

  const totalCount = Object.values(typeContainers).reduce((sum, c) => sum + c.querySelectorAll('.op-code-row').length, 0) + matchedCount;
  chipRow.appendChild(makeChip('All', totalCount, ''));

  if (matchedCount > 0) {
    chipRow.appendChild(makeChip('Fits this boat', matchedCount, '__matched__', true));
  }

  Object.keys(typeContainers).forEach((type) => {
    const count = typeContainers[type].querySelectorAll('.op-code-row').length;
    chipRow.appendChild(makeChip(type, count, type));
  });

  chipRow.querySelectorAll('.op-type-chip').forEach((chip) => {
    chip.addEventListener('click', () => {
      chipRow.querySelectorAll('.op-type-chip').forEach(c => c.classList.toggle('active', c === chip));
      applyOpTypeChipFilter(chip.dataset.opType, { codeBody, searchInput: opts.searchInput, resultCountEl: opts.resultCountEl });
    });
  });
}

function applyOpTypeChipFilter(type, opts = {}) {
  const codeBody = opts.codeBody || document.getElementById('op-code-body');
  codeBody.querySelectorAll('.op-code-row').forEach((row) => {
    if (type === '__matched__') {
      row.classList.toggle('op-type-chip-hidden', !row.classList.contains('customer-specific-op'));
    } else {
      row.classList.toggle('op-type-chip-hidden', !!type && row.dataset.sortType !== type);
    }
  });
  // Hide a type container outright if every row inside it is chip-filtered
  // out (codeSearch() may independently hide/show within what's left).
  codeBody.querySelectorAll('.op-type-container').forEach((container) => {
    const rows = container.querySelectorAll('.op-code-row');
    const anyVisible = Array.from(rows).some(r => !r.classList.contains('op-type-chip-hidden'));
    container.classList.toggle('op-type-chip-hidden', rows.length > 0 && !anyVisible);
  });
  codeSearch(opts.searchInput, codeBody, opts.resultCountEl);
}

function bindOpCodeClickDelegationOnce() {
  const parentContainer = document.getElementById('op-code-body');
  if (!parentContainer) return;

  if (parentContainer.dataset.opClickBound === "1") return;
  parentContainer.dataset.opClickBound = "1";

  parentContainer.addEventListener('click', (e) => {
    if (!e.target.closest('.op-code-row')) return;
    opCodeClicked(e);
  });
}

async function opCodeClicked(e) {
  const row = e?.target?.closest('.op-code-row');
  if (!row) return;

  let data;
  try {
    data = JSON.parse(row.getAttribute('data-opcode') || '{}');
  } catch {
    data = {};
  }

  const desc = String(data.description || '');
  const lowerDesc = desc.toLowerCase();

  if (lowerDesc.includes('shrinkwrap')) shell.wakeShrinkwrapCard();

  document.querySelectorAll('.searchHide').forEach(el => el.classList.remove('searchHide'));

  const storage = document.getElementById('storageStatus')?.value || '';

  const jobEl = document.getElementById('job');
  if (jobEl) jobEl.style.display = 'flex';

  row.classList.add('active-op');

  const setVal = (id, v) => {
    const el = document.getElementById(id);
    if (el) el.value = v ?? '';
  };

  setVal('opCode', data.opCode || '');

  if (desc.includes(':')) {
    setVal('dmShortDesc', desc.split(':')[0]);
  } else if(desc.toLowerCase().includes('shrinkwrap boat')){
    setVal('dmShortDesc','Shrinkwrap Boat')
  }else{
    setVal('dmShortDesc', '');
    if (typeof toastMessage === 'function') toastMessage('Add Short Description', 'red');
    document.getElementById('dmShortDesc')?.focus();
  }

  // Mooring #/weight, paint coats, and discount info used to be collected via
  // blocking prompt() popups right here. They're now inline fields in
  // #opCodeExtraFields (shown/hidden per-op below) wired to
  // rebuildOpDescription() via .oninput, so the user can fill or edit them
  // without a popup and the description stays live as they type.
  currentOpCodeData = data;

  const mooringInput = document.getElementById('work-order-form-boat-mooring-number-slip');
  const mooringNumberField = document.getElementById('mooringNumberField');
  const mooringWeightInput = document.getElementById('work-order-form-boat-mooring-weight');
  const mooringWeightField = document.getElementById('mooringWeightField');
  const coatsField = document.getElementById('coatsField');
  const discountField = document.getElementById('discountField');

  const showsMooring = lowerDesc.includes('mooring');
  if (mooringNumberField) {
    mooringNumberField.style.display = showsMooring ? '' : 'none';
    const el = document.getElementById('opMooringNumber');
    if (el) el.value = mooringInput?.value || '';
  }
  if (mooringWeightField) {
    mooringWeightField.style.display = showsMooring ? '' : 'none';
    const el = document.getElementById('opMooringWeight');
    if (el) el.value = mooringWeightInput?.value || '';
  }

  const showsCoats = lowerDesc.includes('bottom paint') && !lowerDesc.includes('storage');
  if (coatsField) {
    coatsField.style.display = showsCoats ? '' : 'none';
    const el = document.getElementById('opCoatsCount');
    if (el) el.value = '2';
  }

  const showsDiscount = (data.opCode || '') === 'DISCNT';
  if (discountField) {
    discountField.style.display = showsDiscount ? '' : 'none';
    const el = document.getElementById('opDiscountInfo');
    if (el) el.value = '';
  }

  setupOpCodeExtraFieldListeners();

  const workOrderType = document.getElementById('work-order-type-select')?.value || '';
  let mainCategory = document.getElementById('overallCategory')?.value || '';

  const determineCategory = (mainCategory, workOrderType, data) => {

    if (workOrderType === 'storage-work-order') {

      if (data.category === 'General Labor') return data.additional;

    }

    if (workOrderType === 'general-work-order' && mainCategory !== '') return mainCategory;
    
    return data.category || '';
    
  };

  setVal('category', determineCategory(mainCategory, workOrderType, data));

  setVal('opType', data.opType || '');
  setVal('opWeight', data.dependency != null ? String(data.dependency) : '0');
  setVal('estimatedCharge', data.estimatedCharge ?? '');
  setVal('flatMethod', data.flatRateMethod ?? '');
  setVal('flatPerFoot', data.flatRatePerFoot ?? '');
  setVal('flatLabor', data.flatRateLabor ?? '');
  setVal('estimatedHours', data.hours ?? '');

  // F2 header — op code chip + name + "Fits this boat" pill, read straight
  // off the same data/row the rest of this function already uses.
  const headerOpCode = document.getElementById('job-detail-header-opcode');
  if (headerOpCode) headerOpCode.textContent = data.opCode || '';
  const headerName = document.getElementById('job-detail-header-name');
  if (headerName) headerName.textContent = document.getElementById('dmShortDesc')?.value || desc.split(':')[0] || '';
  const headerFitsPill = document.getElementById('job-detail-header-fits-pill');
  if (headerFitsPill) headerFitsPill.classList.toggle('hidden', !row.classList.contains('customer-specific-op'));

  rebuildOpDescription();

  shell.jobAssist.reset();
  shell.jobAssist.refresh();

  const tops = document.getElementsByClassName('jobTop');
  for (const el of tops) el.scrollIntoView();
}

// Set by opCodeClicked() each time an op is selected; lets
// rebuildOpDescription() re-run later from the inline fields' input
// listeners (mooring #/weight, coats, discount) without re-deriving the
// selected op's data from scratch.
let currentOpCodeData = null;
// Loading an existing operation into the form (app.js) sets the code it was made from.
export function setCurrentOpCodeData(data) { currentOpCodeData = data; }

function rebuildOpDescription() {
  const data = currentOpCodeData;
  if (!data) return;

  const desc = String(data.description || '');
  const lowerDesc = desc.toLowerCase();
  const nowYear = new Date().getFullYear();
  const setDesc = v => { const el = document.getElementById('description'); if (el) el.value = v; };

  const mooring = document.getElementById('opMooringNumber')?.value
    || document.getElementById('work-order-form-boat-mooring-number-slip')?.value || '';
  const mooringWeight = document.getElementById('opMooringWeight')?.value
    || document.getElementById('work-order-form-boat-mooring-weight')?.value || '';

  if (lowerDesc.includes('bottom paint') && lowerDesc.includes('storage')) {
    setDesc(desc);
  } else if (lowerDesc.includes('bottom paint') && !lowerDesc.includes('storage')) {
    const coats = parseInt(document.getElementById('opCoatsCount')?.value, 10);
    if (!isNaN(coats) && coats > 0) {
      const numbers = {1:'one',2:'two',3:'three',4:'four',5:'five',6:'six',7:'seven',8:'eight',9:'nine',10:'ten'};
      const word = numbers[coats] || String(coats);
      setDesc(desc + ' Paint boat with ' + word + ' (' + String(coats) + ') coat of anti-fouling paint.');
    } else {
      setDesc(desc);
    }
  } else if ((data.opCode || '') === 'DISCNT') {
    const discountInfo = document.getElementById('opDiscountInfo')?.value || '';
    setDesc('Discount: ' + discountInfo);
  } else if (lowerDesc.includes('remove batter') || lowerDesc.includes('install batter')) {
    const battCount = document.getElementById('work-order-form-boat-battery-count')?.value || '';
    const safeBatteryInfo = battCount === '' ? ' BATTERY COUNT IS UNKNOWN' : ` BATTERY COUNT (${battCount})`;
    setDesc(desc + safeBatteryInfo);
  } else if (
    lowerDesc.includes('general rigging labor') ||
    lowerDesc.includes('general mechanical labor') ||
    lowerDesc.includes('general boat maintenance')
  ) {
    setDesc('');
  } else if (lowerDesc.includes('mooring') && !lowerDesc.includes('haul mooring') && !lowerDesc.includes('mooring placement')) {
    if (mooring && mooring.includes(',')) {
      if (typeof updateDescription === 'function') updateDescription(desc, 1);
    } else {
      setDesc(desc + ' (MOORING: ' + (mooring || '') + ')');
    }
  } else if (lowerDesc.includes('haul mooring')) {
    if (mooring && mooring.includes(',')) {
      if (typeof updateDescription === 'function') updateDescription(desc, 2);
    } else {
      setDesc('HAUL MOORING ' + (mooring || '') + ' ' + nowYear + ' SEASON. ' + (mooringWeight || '') + ' @ $0.70 PER LB.');
    }
  } else if (lowerDesc.includes('mooring placement')) {
    setDesc('PLACE MOORING ' + (mooring || '') + ' ' + nowYear + ' SEASON. ' + (mooringWeight || '') + ' LBS @ $0.70 PER LB.');
  } else {
    setDesc(desc);
  }
}

// Idempotent (re-assigns .oninput/.onclick rather than addEventListener) so
// calling this every time opCodeClicked() runs never stacks duplicate
// handlers. Also syncs mooring #/weight back to the boat's hidden fields so
// later ops on the same work order see the same value without re-typing.
function setupOpCodeExtraFieldListeners() {
  const mooringNumberEl = document.getElementById('opMooringNumber');
  if (mooringNumberEl) {
    mooringNumberEl.oninput = () => {
      const boatField = document.getElementById('work-order-form-boat-mooring-number-slip');
      if (boatField) boatField.value = mooringNumberEl.value.toUpperCase();
      rebuildOpDescription();
    };
  }

  const mooringWeightEl = document.getElementById('opMooringWeight');
  if (mooringWeightEl) {
    mooringWeightEl.oninput = () => {
      const boatField = document.getElementById('work-order-form-boat-mooring-weight');
      if (boatField) boatField.value = mooringWeightEl.value;
      rebuildOpDescription();
    };
  }

  const coatsEl = document.getElementById('opCoatsCount');
  if (coatsEl) coatsEl.oninput = rebuildOpDescription;

  const coatsMinus = document.getElementById('opCoatsMinus');
  if (coatsMinus) coatsMinus.onclick = () => {
    coatsEl.value = Math.max(1, (parseInt(coatsEl.value, 10) || 1) - 1);
    rebuildOpDescription();
  };

  const coatsPlus = document.getElementById('opCoatsPlus');
  if (coatsPlus) coatsPlus.onclick = () => {
    coatsEl.value = Math.min(10, (parseInt(coatsEl.value, 10) || 0) + 1);
    rebuildOpDescription();
  };

  const discountEl = document.getElementById('opDiscountInfo');
  if (discountEl) discountEl.oninput = rebuildOpDescription;
}


export function codeSearch(searchInputEl, rootEl, resultCountEl) {
  const searchInput = searchInputEl || document.getElementById('codeSearch');
  const root = rootEl || document;
  const searchQuery = (searchInput?.value || '').toLowerCase();

  const categoryContainers = root.querySelectorAll('.op-type-container');
  let visibleCount = 0;

  categoryContainers.forEach(categoryDiv => {

    const opCodeRows = categoryDiv.querySelectorAll('.op-code-row');

    let categoryHasVisibleRow = false;

    opCodeRows.forEach(row => {
      if (row.classList.contains('not-interactive')) {
        return;
      }

      const rowData = JSON.parse(row.getAttribute('data-opcode'));
      const isMatch = Object.values(rowData).some(value =>
        String(value).toLowerCase().includes(searchQuery)
      );

      if (searchQuery !== '' && isMatch) {
        row.classList.remove('hidden');
        categoryHasVisibleRow = true;
      } else if (searchQuery !== '') {
        if (!row.classList.contains('hidden')) {
          row.classList.add('hidden');
        }
      } else {
        row.classList.remove('hidden');
      }

      if (!row.classList.contains('hidden') && !row.classList.contains('op-type-chip-hidden')) {
        visibleCount++;
      }
    });

  });

  const countEl = resultCountEl || document.getElementById('op-picker-result-count');
  if (countEl) countEl.textContent = searchQuery ? `${visibleCount} result${visibleCount === 1 ? '' : 's'}` : '';
}

function calculateEstimate(rowData, length, beam, engineCount, batteryCount) {
  if (rowData.Flat_Rate_Length.includes(',')) {
      return Number(length) * Number(rowData.Flat_Rate_Per_Foot);
  } else if (rowData.Flat_Rate_Length.includes('Engine')) {
      return Number(engineCount) * Number(rowData.Flat_Rate_Labor);
  } else if (rowData.Flat_Rate_Length.includes('Generator')) {
      return Number(rowData.Flat_Rate_Labor);
  } else if (rowData.Flat_Rate_Length.includes('Mast')) {
      return Number(Number(length) * 1.3) * Number(rowData.Flat_Rate_Per_Foot);
  } else if (rowData.Flat_Rate_Length.includes('Battery')) {
      return Number(batteryCount) * Number(rowData.Flat_Rate_Labor);
  } else if (rowData.Flat_Rate_Length === '' && rowData.Flat_Rate_Labor === '' && rowData.Hours !== '') {
      return Number(rowData.Hours) * Number(document.getElementById('currentLaborRate').value);
  } else {
      return '';
  }
}

async function updateDescription(info, select) {

  var mooring = document.getElementById('work-order-form-boat-mooring-number-slip').value;
  if (document.getElementById('work-order-form-boat-mooring-weight').value !== '') {
    var mooringWeight = document.getElementById('work-order-form-boat-mooring-weight').value + ' LBS'
  } else { var mooringWeight = '' }


  if (select === 1) {
    var selectedMooring = await showModalWithMooringOptions(mooring);
    document.getElementById('description').value = info + " (MOORING: " + selectedMooring + ")";
  } else if (select === 2) {
    var selectedMooring = await showModalWithMooringOptions(mooring);
    document.getElementById('description').value = "HAUL MOORING " + selectedMooring + " " + new Date().getFullYear() + " SEASON. " + mooringWeight + " @ $0.70 PER LB.";
  }


}

// Persistent "shown, not toasted" checklist (D4) — recomputed from whatever
// is already in the DOM whenever operations or the WO number change, no new
// state of its own.
export function renderWoValidationChecklist() {
  const bar = document.getElementById('wo-validation-bar');
  if (!bar) return;

  const issues = [];
  const oks = [];

  document.querySelectorAll('#activeJobs .wo-job-row').forEach((row) => {
    let record = {};
    try { record = JSON.parse(row.getAttribute('data-job-record') || '{}'); } catch {}
    const label = (record.Short_Description || record.OpCode || 'This operation');
    if (!record.Short_Description || !record.Short_Description.trim()) {
      issues.push({ text: `<b>${escapeHTML(label)}</b> needs a short description`, action: () => row.scrollIntoView({ behavior: 'smooth', block: 'center' }) });
    }
  });

  const formType = document.getElementById('work-order-type-select')?.value;
  const customerChosen = !!document.getElementById('work-order-form-customer-id')?.value;
  const opCount = document.querySelectorAll('#activeJobs .wo-job-row').length;

  // The number is taken automatically with the first operation (addJob), so a missing one is
  // not something to fix: only an empty work order is.
  if (customerChosen && opCount === 0 && formType !== 'estimate') {
    issues.push({ text: 'Add at least one operation', action: () => document.getElementById('selectOpCode')?.click() });
  }

  const woNumbers = (formType === 'storage-work-order' ? ['winterWorkOrder', 'springWorkOrder', 'shrinkwrapWorkOrder'] : ['generalWorkOrder'])
    .map(id => document.getElementById(id)?.value).filter(Boolean);
  if (woNumbers.length) oks.push(`${escapeHTML(woNumbers.join(', '))} assigned`);

  // Only a marina that bills through DockMaster needs the customer linked there.
  if (usesDockmaster() && customerChosen) {
    const dmLinked = !!document.getElementById('work-order-form-customer-DMid')?.value;
    if (dmLinked) oks.push('Customer &amp; boat linked to Dockmaster');
    else issues.push({ text: 'Customer not linked to Dockmaster yet', action: null });
  }

  if (opCount > 0) {
    const hoursText = document.getElementById('wo-ops-hours')?.textContent || '';
    oks.push(`${opCount} operation${opCount === 1 ? '' : 's'}${hoursText ? `, ${hoursText} estimated` : ''}`);
  }

  bar.classList.toggle('hidden', !customerChosen || formType === 'estimate' || (issues.length === 0 && opCount === 0));

  document.getElementById('wo-validation-count-pill').textContent = issues.length ? `${issues.length} to fix` : 'Ready';

  const list = document.getElementById('wo-validation-list');
  list.innerHTML = '';
  issues.forEach((issue) => {
    const el = document.createElement('div');
    el.className = 'wo-validation-item issue';
    el.innerHTML = `<span class="wo-validation-item-mark">&rarr;</span><span>${issue.text}</span>`;
    if (issue.action) el.addEventListener('click', issue.action);
    list.appendChild(el);
  });
  oks.forEach((text) => {
    const el = document.createElement('div');
    el.className = 'wo-validation-item ok';
    el.innerHTML = `<span class="wo-validation-item-mark">&#10003;</span><span>${text}</span>`;
    list.appendChild(el);
  });
}

// A picked mooring op whose boat has several moorings asks which one.
function showModalWithMooringOptions(mooring) {
  return new Promise((resolve) => {
    var mooringArray = mooring.split(',');
    var mooringModal = document.getElementById('mooringModal-mooring');
    var mooringButtonsContainer = document.getElementById('mooringButtons-mooring');

    // Clear previous buttons
    mooringButtonsContainer.innerHTML = '';

    // Create a button for each mooring option
    mooringArray.forEach(function (mooringOption) {
      var button = document.createElement('button');
      button.textContent = mooringOption.trim();
      button.addEventListener('click', function () {
        // Resolve the promise with the selected mooring option
        resolve(mooringOption.trim());
        mooringModal.style.display = 'none';
      });
      mooringButtonsContainer.appendChild(button);
    });

    // Show the modal
    mooringModal.style.display = 'block';

    // Close button
    var closeButton = document.querySelector('.close-mooring');
    closeButton.onclick = function () {
      mooringModal.style.display = 'none';
    };

    // Close the modal when clicking outside of it
    window.onclick = function (event) {
      if (event.target === mooringModal) {
        mooringModal.style.display = 'none';
      }
    };
  });
}
